module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.registerLan.title,
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "rules": _vm.rules,
      "label-width": "80px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.sidebarLan1.roleName,
      "prop": "Role_No"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formLabelAlign.Role_No),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "Role_No", $$v)
      },
      expression: "formLabelAlign.Role_No"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.sidebarLan1.roleDesc,
      "prop": "Desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.formLabelAlign.Desc),
      callback: function($$v) {
        _vm.$set(_vm.formLabelAlign, "Desc", $$v)
      },
      expression: "formLabelAlign.Desc"
    }
  })], 1), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.data2,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "Role_ID",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  }), _vm._v(" "), (!_vm.selectBool) ? _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.selectBtn))]) : _vm._e(), _vm._v(" "), (_vm.selectBool) ? _c('el-button', {
    on: {
      "click": _vm.setCheckedNodes
    }
  }, [_vm._v(_vm._s(_vm.registerLan.emptyBtn))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.no))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.registerLan.logOut.yes))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-452d28be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/add-role-dialog.vue
// module id = 1106
// module chunks = 1